import { Form } from "react-bootstrap";

export const SortingSelect = ({ filters, setFilters, sortingTypes }) => {
    return (
        <Form.Select value={filters.sortType} onChange={(e) => {
            setFilters((prev) => ({
                ...prev,
                sortType: e.target.value,
            }));
        }}>
            {sortingTypes.map((type) => (
                <option key={type} value={type}>
                    {type}
                </option>
            ))}
        </Form.Select>
    )
}